import useStore from "../Zustand/Zustand";
import ZustandFormImovel from "../Zustand/ZustandFormImovel";
import ZustandSelectBankType from "../Zustand/ZustandSelectBankType";
import axios from "axios";

const BASEURL = "https://api-monetare-inter-financiamento.azurewebsites.net/api/inter/simulacao";

async function InterFinApi() {
  const { adicionarSimulacao, setLoading } = useStore.getState();
  const { setDisableSelectdInter } = ZustandSelectBankType.getState();
  const { prazoMeses, valorDeEntrada, valorDoImovel, valorFGTS } =
    ZustandFormImovel.getState();

  try {

    const response = await axios.post(
      BASEURL,
      {
        cliente: {
          dataNascimento: "2000-01-01",
        },
        tipoProduto: "FINANCIAMENTO_IMOBILIARIO",
        valorEntrada: parseFloat(valorDeEntrada) || 0 + parseFloat(valorFGTS) || 0,
        quantidadeParcelas: prazoMeses,
        valorSolicitado: valorDoImovel - valorDeEntrada,
        imovel: {
          valor: valorDoImovel,
          categoria: "CASA_RESIDENCIAL_ISOLADA",
          estado: "MG",
        },
      },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    setLoading(false);
    adicionarSimulacao(response.data);
    setDisableSelectdInter(true);
  } catch (error) { }
}

export default InterFinApi;
